// import '@babel/polyfill';

import $ from 'jquery';

// import _ from 'lodash';

import LazyLoad from 'vanilla-lazyload';

// SimpleShare
import SimpleShare from './plugins/simpleshare/index.js';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// vanilla-cookieconsent
// import cookieConsent from './plugins/cookie-consent';

// import isMobile from 'mobile-device-detect';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

import validate from 'jquery-validation';

import { layer } from './plugins/layer/index.js';

import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';


import axios from 'axios';

import Pjax from 'pjax';
import Sticky from 'sticky-js';

import './forms.js';


import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { cos, Bucket, Region } from './plugins/cos.js';
import { tcVod } from './plugins/vod.js';
import { createFileName, bytesToSize } from './plugins/methods.js';
import ImageCropper from './plugins/image-cropper/index.js';
import {showLayerLoading, hideLayerLoading} from './plugins/layerLoading.js';
import Language from './language.js';
const lang = new Language();
const langCode = $('#lang').val();

(function header() {

	var $header = $('.header'),
		$body = $('body');
	function headerHeight() {
		var winSTop = $(window).scrollTop();
		if (winSTop > 0) {
			$body.addClass('fixed-menu');
		} else {
			$body.removeClass('fixed-menu');
		}
	}

	$(window).on('scroll', function () {
		headerHeight();
	}).trigger('scroll');


	$('.js-goTop').on('click', function () {
		$('html,body').stop().animate({
			scrollTop: 0
		}, 'slow');
	});


	var _scrollTop = 0;

	function getScrollTop() {
		return $(window).scrollTop();
	}
	$(document).on('click', '.js-btnMenu', function () {
		if ($body.hasClass('menu-open')) {
			$body.removeClass('menu-open');
			$(window).scrollTop(_scrollTop);
			$('.container').css({ top: 0 });
		} else {
			_scrollTop = getScrollTop();
			$body.addClass('menu-open');
			$('.container').css({ top: -_scrollTop });
		}
	});

	$('.has-sub').on('click', function () {
		var subMenu = $(this).next('.sub-menu');
		if ($(this).hasClass('show')) {
			$(this).removeClass('show');
			$('body').hasClass('menu-open') ? subMenu.slideUp(200) : ''
		} else {
			$(this).addClass('show');
			$('body').hasClass('menu-open') ? subMenu.slideDown(200) : ''
		}
	});

})();

(function page() {

	if ($('.js-response-bg').length) {
        $(window).on('resize', function(){
            $('.js-response-bg').each(function(index, item){
                var imgPC = $(item).attr('data-pc');
                var imgM = $(item).attr('data-m');
                // console.log(imgPC, imgM, window.innerWidth > 768 ? imgPC : imgM);
                var img = window.innerWidth > 640 ? imgPC : imgM
                $(item).css({
                    'background-image': 'url('+img+')'
                });
            });
        }).trigger('resize');
    }

	if ($('.ib-item').length) {

		$(window).on('resize', function () {
			$('.ib-item').each(function (index, item) {
				var imgPC = $(item).attr('data-pc');
				var imgM = $(item).attr('data-m');
				// console.log(imgPC, imgM, window.innerWidth > 768 ? imgPC : imgM);
				var img = window.innerWidth > 750 ? imgPC : imgM
				$(item).css({
					'background-image': 'url(' + img + ')'
				});
			});
		}).trigger('resize');

	}

	if ($(".js-time").length) {
		const time = $(".js-time").attr("data-time");
		const endTime = new Date(time);
		function updateTime() {
			const nowTime = new Date();
			const time = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
			if (time < 1) {
				clearInterval(intTime);
			} else {
				let d = parseInt(time / 24 / 60 / 60),
					h = parseInt((time / 60 / 60) % 24),
					m = parseInt((time / 60) % 60),
					s = parseInt((time % 60));
				m = m < 10 ? '0' + m : m;
				s = s < 10 ? '0' + s : s;
				$('#countdown-d').html(d);
				$('#countdown-h').html(h);
				$('#countdown-m').html(m);
				$('#countdown-s').html(s);
			}
		}
		const intTime = setInterval(function () {
			updateTime();
		}, 1000);
	}

	if ($(".about-item").length) {
		var aboutObj = {};
		$('.about-item').each(function () {
			var _id = $(this).attr('id');
			aboutObj[_id] = {
				mX: 0,
				mY: 0,
				tX: 0,
				tY: 0
			}
		});
		$('.about-item').on('mousemove', function (e) {
			var _id = $(this).attr('id');
			var obj = aboutObj[_id];
			console.log(obj.mX, obj.mX, '---');
			if (obj.mX != 0) {
				obj.tX += (e.clientX - obj.mX) / 15;
				obj.tY += (e.clientY - obj.mY) / 15;
				$(this).find('img').css({
					'transform': 'translate3d(' + obj.tX + 'px, ' + obj.tY + 'px, 0)'
				});
				$(this).find('.about-item__title').css({
					'transform': 'translate3d(' + obj.tX + 'px, ' + -obj.tY + 'px, 0)'
				});
			}
			obj.mX = e.clientX;
			obj.mY = e.clientY;
		});
		$('.about-item').on('mouseleave', function () {
			var _id = $(this).attr('id');
			var obj = aboutObj[_id];
			obj.mX = 0;
			obj.mY = 0;
			obj.tX = 0;
			obj.tY = 0;

			$(this).find('img').css({
				'transform': 'translate3d(' + obj.tX + 'px, ' + obj.tY + 'px, 0)'
			});
			$(this).find('.about-item__title').css({
				'transform': 'translate3d(' + obj.tX + 'px, ' + -obj.tY + 'px, 0)'
			});
		})
	}

	if ($('.js-pcate').length) {
		var tab = $('.js-pcate');
		var tabTop = tab.offset().top;

		$(window).on('resize', function () {
			tabTop = $('.page-cate').offset().top + 10;
		});

		$(window).on('scroll', function (e) {

			var headerH = $('.header').outerHeight();

			if ($(window).scrollTop() > (tabTop - headerH)) {
				tab.addClass('fixed');
			} else {
				tab.removeClass('fixed');
			}

			$('.pcate-page').each(function () {
				var _h = $(this).offset().top - headerH - 60;
				var _maxH = $(this).offset().top + $(this).outerHeight() - headerH - 60;
				var _id = $(this).attr('id');
				if ($(window).scrollTop() > _h && $(window).scrollTop() < _maxH) {
					$('.js-pcate-tab a').removeClass('current');
					$('.js-pcate-tab a').each(function () {
						if ($(this).attr('href') == '#' + _id) {
							$(this).addClass('current');
						}
					});
				}
			});

		});

		$('.js-pcate-tab a').on('click', function (e) {
			e.preventDefault();
			var id = $(this).attr("href");
			var bodyScroll = $(id).offset().top - $('.header').outerHeight() - 60;
			$('html,body').stop().animate({
				scrollTop: bodyScroll
			}, 'slow');
		});
	}
})();

(function uploadImage() {
	if ($('.js-upload-img').length) {
		$('.js-upload-img').on('change', function (e) {
			const fileObj = e.target.files[0];
			console.log(fileObj);
			var fileObjUrl = window.URL.createObjectURL(fileObj);
			console.log(fileObjUrl);

			const coverBox = $('.'+$(this).data('coverbox'));
			const inputName = $('input[name='+$(this).data('inputname')+']')

			$(this).val('');

			const imagecropper = new ImageCropper({
				imgurl: fileObjUrl,
				width: 720,
				height: 480,
				done: function (blob) {
					// console.log(blob);
					const myFile = new File([blob], 'jpg', {
						type: blob.type,
					});
					// console.log(window.URL.createObjectURL(myFile));
					coverBox.css({
						'background-image': 'url(' + window.URL.createObjectURL(myFile) + ')'
					});

					// console.log('done - cropper');

					const fileName = myFile.name;
					const fileType = myFile.type;
					const fileExtension = fileName.split('.').pop().toLowerCase();
					const newFileName = createFileName(24) + '.' + fileExtension;
					showLayerLoading();
					cos.uploadFile({
						Bucket: Bucket, /* 填写自己的bucket，必须字段 */
						Region: Region,     /* 存储桶所在地域，必须字段 */
						Key: newFileName,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
						Body: myFile, // 上传文件对象
						SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
						onProgress: function (progressData) {
							// console.log(JSON.stringify(progressData));
						}
					}, function (err, data) {
						if (err) {
							// console.log('上传失败', err);
						} else {
							// console.log('上传成功');
							console.log(data);
							inputName.val(newFileName);
							// console.log(newFileName);
						}
						hideLayerLoading();
					});

				}
			});

		});
	}

	if ($('.js-upload-wcover').length) {
		$('.js-upload-wcover').on('change', function (e) {
			const fileObj = e.target.files[0];
			console.log(fileObj);
			var fileObjUrl = window.URL.createObjectURL(fileObj);
			console.log(fileObjUrl);

			$(this).val('');
			const imagecropper = new ImageCropper({
				imgurl: fileObjUrl,
				width: 720,
				height: 480,
				done: function (blob) {
					// console.log(blob);
					const myFile = new File([blob], 'jpg', {
						type: blob.type,
					});
					// console.log(window.URL.createObjectURL(myFile));
					$('.wcover-label').css({
						'background-image': 'url(' + window.URL.createObjectURL(myFile) + ')'
					});

					console.log('done - cropper');

					const fileName = myFile.name;
					const fileType = myFile.type;
					const fileExtension = fileName.split('.').pop().toLowerCase();
					const newFileName = createFileName(24) + '.' + fileExtension;
					showLayerLoading();
					cos.uploadFile({
						Bucket: Bucket, /* 填写自己的bucket，必须字段 */
						Region: Region,     /* 存储桶所在地域，必须字段 */
						Key: newFileName,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
						Body: myFile, // 上传文件对象
						SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
						onProgress: function (progressData) {
							console.log(JSON.stringify(progressData));
						}
					}, function (err, data) {
						if (err) {
							// console.log('上传失败', err);
						} else {
							// console.log('上传成功');
							// console.log(data);
							$('input[name=wcover_name]').val(newFileName);
							// console.log(newFileName);
						}
						hideLayerLoading();
					});

				}
			});




		});
	}

	if ($('.js-upload-multiple-img').length) {
		const fileInput = document.getElementById('file');
		let fileList = [];

		const upConfig = {
			fileType: ['image/jpg', 'image/jpeg', 'image/bmp', 'image/png'],    //支持的图片格式
			fileSize: 1024 * 1024 * 5,                      //单张图片大小不得超过5M
			max: 10                                 //最多上传10张图片
		}

		$('#file').on('change', function () {
			let filesArr = fileInput.files;
			filesArr = Array.prototype.slice.call(filesArr);

			$(this).val('');

			for (let i = 0; i < filesArr.length; i++) {
				const imgUrl = window.URL.createObjectURL(filesArr[i]);
				const size = bytesToSize(filesArr[i].size);
				const datafileid = $(".file-item").length + 1;

				if (filesArr[i].size > upConfig.fileSize) {

					console.log(filesArr[i].size);
					layer.msg(lang.uploadImageSizeTwo)
					return false;
				}

				if (datafileid > upConfig.max) {
					layer.msg(lang.uploadImageMax)
					return false;
				}

				if (fileList.length < upConfig.max) {
					fileList.push(filesArr[i]);


					const imageItem = document.createElement('div');
					imageItem.className = 'file-item';

					imageItem.innerHTML = `<input class="file-item__name" type="hidden" name="images[]" value="">
					<div class="file-item__bg"></div>
					<svg class="file-item__loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
						<circle cx="50" cy="50" fill="none" stroke="#292726" stroke-width="5" r="20" stroke-dasharray="94.24777960769379 33.41592653589793">
							<animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
						</circle>
					</svg>
					<div class="file-item__close js-file-delete icon-close"></div><p class="file-item__size">` + size + `</p>`;

					const imageBox = document.querySelector('.js-upload-multiple-box');
					const imageItemBg = imageItem.querySelector('.file-item__bg');
					const imageItemLoading = imageItem.querySelector('.file-item__loading');
					const imageInput = imageItem.querySelector('.file-item__name');

					imageBox.appendChild(imageItem);

					const fileName = filesArr[i].name;
					const fileExtension = fileName.split('.').pop().toLowerCase();
					console.log(fileExtension);
					const newFileName = createFileName(24) + '.' + fileExtension;
					cos.uploadFile({
						Bucket: Bucket, /* 填写自己的bucket，必须字段 */
						Region: Region,     /* 存储桶所在地域，必须字段 */
						Key: newFileName,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
						Body: filesArr[i], // 上传文件对象
						SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
						onProgress: function (progressData) {
							console.log(JSON.stringify(progressData));
						}
					}, function (err, data) {
						if (err) {
							// console.log('上传失败', err);
						} else {
							// console.log('上传成功');
							console.log(data);
							imageInput.value = newFileName;
							imageItemBg.style.backgroundImage = `url(//`+ data.Location +`?imageMogr2/thumbnail/140x)`;
							imageItemLoading.remove();
						}
					});


				} else {
					// layer.msg('上传图片不得超过2Mb，请重新选择。');
					layer.msg(lang.uploadImageMax);
					return false;
				}
			}
		});

		// 删除图片
		$(document).on('click', '.js-file-delete', function () {
			$(this).parents('.file-item').remove();
		});

	}

	if ($('.js-upload-pdf')) {
		$('.js-upload-pdf').on('change', function(e) {
            const file = e.target.files[0];

            const input = $(this);
            console.log(file);

			$(this).val('');
            // 只选择PDF文件
            if (!file.type.match('application/pdf')) {
                const obj = document.getElementById('pdf1');
				layer.msg(lang.errorPdfFormat)
                obj.value = '';
                return false;
            }

            if(file.size >(10*1024*1024)){
                const obj = document.getElementById('pdf1');
				layer.msg(lang.uploadFileSizeTen)
                obj.value = '';
                return false;
            }

			const fileName = file.name;
			const fileType = file.type;
			const fileExtension = fileName.split('.').pop().toLowerCase();
			const newFileName = createFileName(16) + '.' + fileExtension;

			$('.js-upload-pdf-loading').addClass('show');

			cos.uploadFile({
				Bucket: Bucket, /* 填写自己的bucket，必须字段 */
				Region: Region,     /* 存储桶所在地域，必须字段 */
				Key: newFileName,              /* 存储在桶里的对象键（例如:1.jpg，a/b/test.txt，图片.jpg）支持中文，必须字段 */
				Body: file, // 上传文件对象
				SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */
				onProgress: function (progressData) {
					console.log(JSON.stringify(progressData));
				}
			}, function (err, data) {
				if (err) {
					// console.log('上传失败', err);
				} else {
					// console.log('上传成功');
					// console.log(data);
					$('input[name=pdf_cos]').val(newFileName);
					$('input[name=pdf_name]').val(fileName);
					$('.js-upload-pdf-label').html(fileName);
					$(".js-clear-pdf").show();
					$('.js-upload-pdf-loading').removeClass('show');
					// console.log(newFileName);
				}
			});

        });

		$(".js-clear-pdf").on('click', function(){
			$('.js-upload-pdf-label').html(lang.selectFile);
			$(".js-clear-pdf").hide();
			$('input[name=pdf_cos]').val('');
			$('input[name=pdf_name]').val('');
		});

	}

	if ($('.js-upload-video')) {

		$('.js-upload-video').on('change', function(e){
			var file = e.target.files[0];

            var input = $(this);
			$(this).val('');
            // 只选择视频文件
            if (!file.type.match('video.mp4')) {
				layer.msg(lang.errorVideoFormat)
                return false;
            }

            if(file.size >(200*1024*1024)){
				layer.msg(lang.uploadFileSizeTwenty);
                return false;
            }


			const fileName = file.name;
			const fileType = file.type;
			const fileExtension = fileName.split('.').pop().toLowerCase();
			const newFileName = createFileName(16) + '.' + fileExtension;
			$('.js-upload-video-loading').addClass('show');
			const uploader = tcVod.upload({
				mediaFile: file, // 媒体文件（视频或音频或图片），类型为 File
				mediaName: newFileName
			});
	
			uploader.on('media_progress', function(info) {
				console.log(info.percent) // 进度
			});
	
			uploader.done().then(function (doneResult) {
				console.log(doneResult);
				// console.log('上传成功');
				$('input[name=wvideo_url]').val(doneResult.video.url);
				$('input[name=wvideo_name]').val(fileName);
				$('input[name=fileId]').val(doneResult.fileId);
				$('.js-upload-video-box').html(fileName);
				$(".js-upload-video-clear").show();
				$('.js-upload-video-loading').removeClass('show');
				// console.log(newFileName);
			}).catch(function (err) {
				// deal with error
				// layer.msg('上传失败请刷新后重试');
			});

		});

		$('.js-upload-video-clear').on('click', function(){
			$('input[name=wvideo_url]').val('');
			$('input[name=wvideo_name]').val('');
			$('input[name=fileId]').val('');
			$('.js-upload-video-box').html(lang.selectVideo);
			$(".js-upload-video-clear").hide();
		});
		
	}

})();

(function vote() {

	$('.js-confirm-voting').on('click', function(){
		console.log('confirm');
		layer.confirmVotingResult(
			function() {
				console.log('confirm - layer');
			}
		);
	});

	$('.js-vw-vote').on('click', function(){
		layer.confirmVoteScore(
			function() {
				console.log('vote - layer');
			}
		)
	});

	$('.js-show-imggrid').on('click', function(){
		$('.vw-body').toggleClass('show-imglist');
	});



	if ($('.splide-vwimg').length) {
		const splideVW = new Splide( '.splide-vwimg', {
			type  : 'fade',
  			rewind: true
		} ).mount();

		$('.js-vwimg-prev').on('click', function(){
			splideVW.go('<')
		});
		$('.js-vwimg-next').on('click', function(){
			splideVW.go('>')
		});
		
		const len  = $('.list-vwimg > li').length;
		$('.js-vwimg-all').html(len < 10 ? '0'+len : len);

		splideVW.on( 'moved', function (newIndex, prevIndex, destIndex) {
			const now = newIndex+1;
			$('.js-vwimg-now').html(now < 10 ? '0'+now : now);
		});
	}

	$('.js-show-vwintro').on('click', function(){
		$('.vw-body').toggleClass('show');
	});


	


	if ($('.pvote-table').length) {
		let pjax = new Pjax({
			elements: '.js-pjax',
			selectors: ['.js-pjax-list', '.js-pjax-nav'],
			scrollTo: false
		});

		const url = $('.pvote-table').data('url');

		// console.log();
		
		$(document).on('change', ".pvotet-checkbox",function(){
			// var that = $(this);
			// var parentThat = that.parent().parent(".pvotet-item");
			// var type = that.attr('data-type');
			// var id = that.attr('data-id');
			const type = $(this).data('type');
			const id = $(this).data('id');

			const formData = new FormData();
			formData.append("type", type);
			formData.append("id", id);
			console.log(type, id);
			axios.post(url, formData)
			.then(function (res) {
				console.log(res);
				if (res.data.success) {
					console.log('success');
					pjax.loadUrl(window.location.href);
				} else {

				}
			})
			.catch(function (error) {
				console.log(error);
			});
		
		});

		$(document).on('click', '.js-pvotet-msg', function(){
			const id = $(this).data('id');
			const msg = $(this).data('msg');
			console.log(msg);
			const url = $(this).data('url');
			const msgBox = document.createElement('div');
			msgBox.classList = 'layer-vmsg-box';
			const temp = `<div class="layer-vmsg">
							<div class="layer-vmsg__bg js-lvmsg-close"></div>
							<div class="layer-vmsg__main bg-white">
								<span class="lvmsg-close js-lvmsg-close icon-close fz-14 black"></span>
								<form action="${url}" autocomplete="off" class="lvmsg-form">
									<input type="hidden" name="id" value="${id}">
									<div>
										<textarea class="lvmsg-textarea fz-16 black" name="msg" id="" rows="5" required>${msg}</textarea>
									</div>
									<div class="text-right mt-10">
										<button class="lvmsg-submit btn-submit js-lvmsg-submit fz-16 black bg-yellow">${lang.btnConfirm}</button>
									</div>
								</form>
							</div>
						</div>`;
			msgBox.innerHTML = temp;
			document.body.appendChild(msgBox);
	
	
			let isSubmit = true;
			const form = $('.lvmsg-form');
			const btnSubmit = msgBox.querySelector('.btn-submit');
			form.validate({
				submitHandler: function(form) {
					if (isSubmit) {
						isSubmit = false;
						const postURL = $(form).attr('action');
						const postData = $(form).serialize();
	
						axios.post(postURL, postData)
						.then(function (res) {
							// console.log(res);
							// console.log(langCode);
							let msg;
							msg = langCode == 'en' ? res.data.info : res.data.info_cn
							// console.log(msg, res.data.success);
							if (res.data.success) {
								$('.layer-vmsg-box').remove();
								layer.msg(msg, {time: 2000}, function(){
									pjax.loadUrl(window.location.href);
								});
							} else {
								layer.msg(msg);
							}
							isSubmit = true;
						})
						.catch(function (err) {
							// console.log(err);
							let msg;
							msg = langCode == 'en' ? err.data.info : err.data.info_cn
							layer.msg(msg);
							isSubmit = true;
						});
					}
				},
				rules: {
					msg: {
						required: false
					}
				},
				messages: {
					msg: {
						required: lang.required
					}
				}
			})
			btnSubmit.addEventListener('click', function(){
				form.submit();
			});
		});
		$(document).on('click', '.js-lvmsg-close', function(){
			$('.layer-vmsg-box').remove();
		});
		$(document).on('click', '.js-lvmsg-submit', function(){
			// $('.layer-vmsg').remove();
		});
	}

	if ($('.js-pjax-list-vote').length) {
		let pjax = new Pjax({
			elements: '.js-pjax',
			selectors: ['.js-pjax-list-vote', '.js-ajax-nav'],
			scrollTo: false
		});

		$(document).on('click', ".js-works-adopt", function(e){
			e.preventDefault();
			const url = $(this).data('url');
			axios.post(url)
			.then(function(res){
				// console.log(res);
				let msg;
				if (res.data.success) {
					pjax.loadUrl(window.location.href)
				} else {
					msg = langCode == 'en' ? res.data.info : res.data.info_cn
					layer.msg(msg);
				}
			})
			.catch(function(err){
				console.log(err);
			})
		});

		$(document).on('click', '.js-works-abstain', function (e) {
			e.preventDefault();
			const url = $(this).data('url');
			axios
				.post(url)
				.then(function (res) {
					// console.log(res);
					let msg;
					if (res.data.success) {
						pjax.loadUrl(localUrl);
						// pjax.reload();
					} else {
						msg = langCode == 'en' ? res.data.info : res.data.info_cn;
						layer.msg(msg);
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		});

		$(document).on('click', ".js-works-detele", function(e){
			e.preventDefault();
			const url = $(this).data('url');
			layer.dialog(lang.widthdraw, [lang.btnConfirm, lang.btnCancel], 
				[function(){
					console.log('yes');
					axios.post(url)
					.then(function(res){
						console.log(res);
						let msg;
						if (res.data.success) {
							// layer.msg()
							pjax.loadUrl(window.location.href)
						} else {
							msg = langCode == 'en' ? res.data.info : res.data.info_cn
							layer.msg(msg);
						}
					})
					.catch(function(err){

					})
				},function(){
					console.log('no');
				}]
			)
		});

		$(document).on('click', ".js-works-collect", function(e){
			e.preventDefault();
			const url = $(this).data('url');
			axios.post(url)
			.then(function(res){
				// console.log(res);
				let msg;
				if (res.data.success) {
					pjax.loadUrl(window.location.href)
				} else {
					msg = langCode == 'en' ? res.data.info : res.data.info_cn
					layer.msg(msg);
				}
			})
			.catch(function(err){
				console.log(err);
			})
		});
	}

	const calcVHeight = () => {
		const h = window.innerHeight - $('.header').outerHeight() - $('.vw-header').outerHeight() - $('.vw-footer').outerHeight();

		$('.vw-body').css({
			height: `${h}px`
		});
		$('.vwimg-item').css({
			height: `${h-140}px`
		});
	}
	if ($('.vw-body').length) {
		$(window).on('resize', function(){
			calcVHeight();
		}).trigger('resize');
	}
	
	if ($('.js-sticky-nav').length) {
		$('.js-sticky-nav').attr('data-margin-top', $('.header').outerHeight());
		var sticky = new Sticky('.js-sticky-nav');
	}

})();

(function init() {
	if ($('.js-inputTel').length) {
		$('.js-inputTel').each(function (index, item) {
			let country = $(item).data('country');
			country = country ? country : 'us'
			const iti = intlTelInput(item, {
				// any initialisation options go here
				initialCountry: country,
				preferredCountries: ["cn", "us"],
				formatOnDisplay: false,
				autoPlaceholder: "",
				separateDialCode: true
			});
		})
	}

	// if (isMobile.isMobile) {
	// 	console.log('Mobile');
	// } else {
	// 	console.log('Tablet');
	// }

	// cookieConsent();

	// Lazyload data-src data-bg data-poster
	var myLazyLoad = new LazyLoad({
		threshold: 800
	});

	// Social Share
	const share = new SimpleShare({
		url: '',
		title: '',
		content: '',
		pic: ''
	});
	$('[data-share]').on('click', function () {
		const type = $(this).attr('data-share');
		share.goShare(type);
	});

})();
